// 航次花絮列表
export function gagsLists() {
    return [
        {
            "id":'2022',
            "title": '2022年共享航行计划',
            "time": '202201-202212',
        },
        {
            "id":'2021',
            "title": '2021年共享航行计划',
            "time": '202101-202112',
        },
        {
            "id":'2020',
            "title": '2020年共享航行计划',
            "time": '202001-202012',
        },
        {
            "id":'2019',
            "title": '2019年共享航行计划',
            "time": '201901-201912',
        },
        {
            "id":'2018',
            "title": '2018年共享航行计划',
            "time": '201801-201812',
        },
        {
            "id":'2017',
            "title": '2017年共享航行计划',
            "time": '201701-201712',
        },
    ]
}

// 22年航次花絮
export function diaryLists() {
    return [
        {
            "id":'101',
            "pid":'2022',
            "img":require('../statics/about-me.png'),
            "title": '2022年5月，南海中部海盆综和调查航次，航次执行中',
            "introduce": 'We have come full circle in our sampling endeavours. If you remember we started the trip a day late due to an emergency tooth extraction, and we arrived home a day late due to an emergency medical evacuation that diverted us to the Chatham Islands. Our chief engineer got hydrofluorocarbon poisoning while working on one of the engine cooling systems. Thankfully, he is doing fine and even came to meet us in Wellington when we docked.',
            "time": '2022-1101',
            //    航次基本信息
            'essential_info':'航次基本信息',
        },
        {
            "id":'102',
            "pid":'2022',
            "img":require('../statics/about-me.png'),
            "title": 'NORC2022-01 台湾海峡共享航次',
            "introduce": 'We have finished sampling our leg of the Geotraces GP13 transect. There are still a few more experiments to complete and a few more surface samples to collect on the way home, but for the most part our sampling is finished. The people that were working 12 hour shifts are slowly resetting their body clocks as we make the seven day steam back to Wellington.',
            "time": '2022-1101',
            //    航次基本信息
            'essential_info':'航次基本信息',
            // 对应项目日记
            "children":[
                {
                    "id":'10201',
                    'title': '出海遇到的海豚',
                    'content':'今天阳光明媚，难得在航次期间看到海豚，按照\n' +
                        '\n' +
                        '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                        '\n' +
                        '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                        '\n' +
                        '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                        '\n' +
                        '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                        '\n' +
                        '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                        '\n' +
                        '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                        '\n' +
                        '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                        '\n' +
                        '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                        '\n' +
                        '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                        '\n' +
                        '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                        '\n' +
                        '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                        '\n' +
                        '还好这微弱的求救信号，被船上的人看在眼里。'
                },
                {
                    "id":'10202',
                    'title': '《【地球日】今天，请收下这张4.8亿像素的地球照片》',
                    'content':'今天阳光明媚，难得在航次期间看到海豚，按照\n' +
                        '\n' +
                        '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                        '\n' +
                        '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                        '\n' +
                        '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                        '\n' +
                        '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                        '\n' +
                        '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                        '\n' +
                        '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                        '\n' +
                        '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                        '\n' +
                        '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                        '\n' +
                        '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                        '\n' +
                        '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                        '\n' +
                        '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                        '\n' +
                        '还好这微弱的求救信号，被船上的人看在眼里。'
                }
            ],
        },
        {
            "id":'103',
            "pid":'2022',
            "img":'',
            "title": '24 JUNE 2011, BY MELANIE GAULT-RINGOLD',
            "introduce": '',
            "time": '2022-1101',
            //    航次基本信息
            'essential_info':'航次基本信息',
            // 对应项目日记
            "children":[],
        },
        {
            "id":'104',
            "pid":'2022',
            "img":'',
            "title": '24 JUNE 2011, BY MELANIE GAULT-RINGOLD',
            "introduce": 'resetting their body clocks as we make the seven day steam back to Wellington.',
            "time": '2022-1101',
            //    航次基本信息
            'essential_info':'航次基本信息',
            // 对应项目日记
            "children":[],
        },
    ]
}

// 22年6月日记列表
export function dataLists(){
    return [
        {
            'id':'10101',
            'pid':'101',
            'title': 'Day 38: 偶遇海豚',
            "img":require('../statics/u168.jpg'),
            // 日记书写日期
            'time':'2022-07-08',
            'content':'今天阳光明媚，难得在航次期间看到海豚，按照\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。'
        },
        {
            "id":'10102',
            'pid':'101',
            'title': '大体积泵作业',
            "img":require('../statics/u173.jpg'),
            // 日记书写日期
            'time':'2022-06-30',
            'content':'今天阳光明媚，难得在航次期间看到海豚，按照\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。'
        },
        {
            "id":'10201',
            'title': '出海遇到的海豚',
            'pid':'102',
            "img":require('../statics/u168.jpg'),
            // 日记书写日期
            'time':'2022-06-20',
            'content':'今天阳光明媚，难得在航次期间看到海豚，按照\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。'
        },
        {
            "id":'10202',
            'pid':'102',
            "img":require('../statics/u173.jpg'),
            'title': '《【地球日】今天，请收下这张4.8亿像素的地球照片》',
            'content':'今天阳光明媚，难得在航次期间看到海豚，按照\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。\n' +
                '\n' +
                '那人看起来很虚弱的样子，没法做到用力挥手，\n' +
                '\n' +
                '只是用尽全力举起手臂一次，然后就无力动弹了。\n' +
                '\n' +
                '还好这微弱的求救信号，被船上的人看在眼里。'
        }
    ]
}
